import type { TOffersDealType, TOffersPropertyType } from 'shared/types/buildingOffers';

/**
 * Подписи блока предложений — как в бандле монолита
 * (`static/cf/src/bundles/business_shopping_center_detail`)
 */

/** Порядок и подписи типов фильтра и якорей (`serp_filters.tsx`) */
export const OFFERS_PROPERTY_TYPES: Array<{ type: TOffersPropertyType; label: string }> = [
  { type: 'office', label: 'Офисы' },
  { type: 'shoppingArea', label: 'Торговые площади' },
  { type: 'warehouse', label: 'Склады' },
  { type: 'freeAppointment', label: 'ПСН' },
];

/** Порядок выбора сделки по умолчанию (`DEAL_TYPES` в `serp.tsx`) */
export const OFFERS_DEAL_TYPES: Array<{ type: TOffersDealType; label: string }> = [
  { type: 'rent', label: 'Аренда' },
  { type: 'sale', label: 'Продажа' },
];

/** Заголовок превью и род для «свободен / занят» (`CommercialPropertyDict`, `api/offer.ts` монолита) */
export const OFFER_PROPERTY_TITLES: Record<TOffersPropertyType, { title: string; free: string; occupied: string }> = {
  office: { title: 'Офис', free: 'свободен', occupied: 'занят' },
  warehouse: { title: 'Склад', free: 'свободен', occupied: 'занят' },
  shoppingArea: { title: 'Торговая площадь', free: 'свободна', occupied: 'занята' },
  freeAppointment: { title: 'Помещение свободного назначения', free: 'свободно', occupied: 'занято' },
};

/** Состояние помещения (`CommercialConditionDict` монолита) */
export const OFFER_CONDITION_LABELS: Partial<Record<string, string>> = {
  office: 'Офисная отделка',
  finishing: 'Под чистовую отделку',
  majorRepairsRequired: 'Требуется капитальный ремонт',
  cosmeticRepairsRequired: 'Требуется косметический ремонт',
  typical: 'Типовой ремонт',
  design: 'Дизайнерский ремонт',
};

/** `office_type` выдачи (`categoryOfficeTypeMap` монолита) */
export const OFFERS_OFFICE_TYPES: Record<TOffersPropertyType, number> = {
  office: 1,
  shoppingArea: 2,
  warehouse: 3,
  freeAppointment: 5,
};
